import Fields from '@components/fields'
import Row from '@components/row'
import { Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Stylesubtitle, StyleTitle } from '../style'
import Button from '@components/button'
import styled from '@emotion/styled'
import generalSettings from '@apis/generalSettings'
import { toast } from 'react-toastify'

// ===== Responsive Row =====
const ResponsiveRow = styled(Row)`
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
`

// ===== Columns =====
const LeftColumn = styled.div`
  flex: 2;
  min-width: 300px;

  @media (max-width: 768px) {
    width: 100%;

    margin-bottom: 10px;
  }
`

const RightColumn = styled.div`
  flex: 1;
  min-width: 250px;

  @media (max-width: 768px) {
    width: 100%;
  }
`

// ===== Form Container =====
const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 15px;
    gap: 12px;
  }

  input {
    width: 100%;
    box-sizing: border-box;
  }

  button {
    @media (max-width: 768px) {
      width: 100%;
    }
  }
`

// ===== Button Container =====
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: center;
    button {
      width: 100%;
    }
  }
`

const RescheduleSetting = () => {
  const [existing, setExisting] = useState<any | null>(null)

  // Fetch existing reschedule setting
  const fetchSetting = async () => {
    try {
      const data = await generalSettings.getByKey({
        id: 'reschedule-days',
        state: 'rescheduleSetting',
      })
      if (data) setExisting(data)
    } catch (err) {
      console.error('Failed to fetch reschedule setting', err)
    }
  }

  useEffect(() => {
    fetchSetting()
  }, [])

  const handleSubmit = async (values: { beforeDays: string }) => {
    const payload = {
      key: 'reschedule-days',
      value: values.beforeDays,
    }
    if (!existing?.id) {
      payload.group = 'platform-settings'
    }
    try {
      if (existing?.id) {
        await generalSettings.update({
          id: existing.id,
          state: 'rescheduleSetting',
          data: payload,
        })
        toast.success('Reschedule settings updated')
      } else {
        await generalSettings.create({
          state: 'rescheduleSetting',
          data: JSON.stringify(payload),
        })
      }
    } catch (err) {
      console.error('Failed to save reschedule setting', err)
    }
  }

  return (
    <ResponsiveRow>
      <LeftColumn>
        <StyleTitle>Reschedule Settings</StyleTitle>
        <Stylesubtitle>
          Admin can manage how many days ahead user can reschedule their ticket
        </Stylesubtitle>
      </LeftColumn>

      <RightColumn>
        <Formik
          enableReinitialize
          initialValues={{ beforeDays: existing?.value || '' }}
          onSubmit={handleSubmit}
        >
          <FormContainer>
            <Fields.Input
              name="beforeDays"
              label="Reschedule before Days"
              placeholder="User can reschedule travel a few days before"
            />
            <ButtonContainer>
              <Button type="submit" title="Save Settings" justify="end" />
            </ButtonContainer>
          </FormContainer>
        </Formik>
      </RightColumn>
    </ResponsiveRow>
  )
}

export default RescheduleSetting
